import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ButtonBase from "@mui/material/ButtonBase";
import CloseIcon from "@mui/icons-material/Close";

import { NewlineText, getInfoModalText } from "../../utils/bedBuilder.utils";
import {
  currentStepDoubleSleeperMattressBuilderSelector,
  currentStepSingleSleeperMattressBuilderSelector,
  currentlyEditingSleeperSelector,
  setIsIncorporateModalOpen,
  setIsSummaryModalOpen,
} from "../../redux/slices/customNavigation";
import { useTheme } from "@mui/styles";
import EvrbedModal from "./EvrbedModal";

import ModalTitle from "../TextComponents/ModalTitle";

import ExitButton from "./ExitButton";

import { isSingleSleeperSelector } from "../../redux/slices/mattressConfiguration";

import React from "react";
import styled from "styled-components";

const StyledModalContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 5vh;
  width: 45vw;
  height: 75vh;
`;

const IncorporateModal = ({ open }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const currentStepSingleSleeperMattressBuilder = useSelector(
    currentStepSingleSleeperMattressBuilderSelector
  );
  const currentStepDoubleSleeperMattressBuilder = useSelector(
    currentStepDoubleSleeperMattressBuilderSelector
  );
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;
  const stepIndex = isSingleSleeper
    ? currentStepSingleSleeperMattressBuilder
    : currentStepDoubleSleeperMattressBuilder;
  return (
    <EvrbedModal
      title={"Evrbed Mattress Information"}
      open={open}
      toggleModal={isOpen => dispatch(setIsIncorporateModalOpen(isOpen))}
      styles={{ background: "white" }}
    >
      <StyledModalContainer className="text-center row">
        <ExitButton
          onClick={() => dispatch(setIsIncorporateModalOpen(false))}
        ></ExitButton>
        <ModalTitle
          className="evrbed-help-modal-title"
          styles={{ width: "60%", marginBottom: "20px" }}
        >
          {t("How We Incorporate This Into Your evrbed")}
        </ModalTitle>
        <div
          className="text-start evrbed-help-modal-title"
          style={{
            paddingRight: "15%",
            paddingLeft: "15%",
            fontSize: "1rem",
            marginTop: "-5vh",
            color: theme.COLORS.BLUE.darkBlueGreen,
          }}
        >
          <NewlineText text={getInfoModalText(stepIndex - 1)} />
        </div>
        {/*<div*/}
        {/*  className="text-start"*/}
        {/*  style={{ paddingRight: "10%", paddingLeft: "10%", marginTop: "-10%" }}*/}
        {/*>*/}
        {/*  {t(*/}
        {/*    "Pellentesque quis tellus dictum, vestibulum nibh vitae, volutpat ex. Integer justo nunc, tempor sed mauris vitae, consequat auctor nulla. Fusce eget hendrerit metus, nec eleifend massa. Pellentesque ut justo eu arcu rutrum scelerisque nec et odio. Nullam fermentum, magna ac ornare hendrerit, magna ligula posuere diam, vitae dapibus nunc odio vel massa. Donec id sem eu nibh tincidunt sodales. Nullam laoreet orci sed ex porttitor elementum. Nunc suscipit fermentum odio, at posuere nisi dignissim vel. Vivamus ut metus neque. Etiam eleifend pulvinar dui, sit amet bibendum augue blandit ut."*/}
        {/*  )}*/}
        {/*</div>*/}
      </StyledModalContainer>
    </EvrbedModal>
  );
};

export default IncorporateModal;
